import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listAllMagistrados:[],
};
export const mutations = {
  GET_MAGISTRADOS({ context }, magistrados) {
    let magistrados_array = [];
    Object.entries(magistrados).forEach(([key, val]) => magistrados_array.push(val));
    return (state.listAllMagistrados= magistrados_array);
  },
};
export const actions = {
  GET_ALL_MAGISTRADOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_MAGISTRADOS", response.data.data.magistrados);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {
  listAllMagistrados: state => state.listAllMagistrados
};
